import { Target, ShieldCheck, Users } from "lucide-react";
import SEO from "../components/SEO";
import LandingNav from "../components/landing/LandingNav";
import LandingFooter from "../components/landing/LandingFooter";

export default function About() {
  return (
    <div className="min-h-screen bg-background" data-testid="about-page">
      <SEO title="About hireqix Resume Screener" description="Learn about hireqix's mission to make hiring faster, fairer, and evidence-based with structured resume screening." keywords="about hireqix, resume screening company, evidence-based hiring, HR software mission" canonicalPath="/about" />
      <LandingNav />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <span className="text-xs font-bold uppercase tracking-widest text-primary">About Us</span>
        <h1 className="mt-3 font-heading text-3xl font-bold tracking-tight sm:text-4xl">Hiring should be fast, fair and evidence-based</h1>
        <p className="mt-5 text-base leading-relaxed text-muted-foreground">
          hireqix was built to solve a simple problem: hiring teams drown in resumes while great candidates get lost in the pile. We combine automated screening with a
          structured, evidence-first evaluation framework so every candidate is scored consistently against the exact competencies that matter for the role —
          not gut feeling, not keyword matching.
        </p>
        <p className="mt-4 text-base leading-relaxed text-muted-foreground">
          Our multi-batch evaluation model means recruiters can keep growing their candidate pool for a role over days or weeks without ever losing earlier
          results — every upload session becomes its own clean, comparable batch.
        </p>

        <div className="mt-12 grid gap-6 sm:grid-cols-3">
          <ValueCard icon={Target} title="Evidence-Based" desc="Scores are grounded strictly in resume content — no assumptions, no fabricated experience." />
          <ValueCard icon={ShieldCheck} title="Bias-Resistant" desc="Every candidate is measured against the same weighted competency matrix, every time." />
          <ValueCard icon={Users} title="Built for Teams" desc="Multi-tenant workspaces let your whole hiring team collaborate on the same ranked shortlist." />
        </div>
      </section>
      <LandingFooter />
    </div>
  );
}

function ValueCard({ icon: Icon, title, desc }) {
  return (
    <div className="rounded-2xl border border-border/70 bg-card p-6 shadow-sm">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/15">
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <h3 className="mt-4 font-heading font-semibold">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{desc}</p>
    </div>
  );
}
